module.exports = __webpack_public_path__ + "img/9791186821640.0631e920.jpg";